import styled from "styled-components";
import { SLForm } from "~/pages/Sistema/componentes/SistemaList";
import { Colors } from "~/config/Colors";

export const Container = styled(SLForm)`
  width: 100%;
  max-width: 100%;

  .row {
    margin-bottom: 0.5rem;
  }

  .no-padding {
    padding: 0 !important;
  }

  .no-margin {
    margin: 0 !important;
  }

  .header {
    padding: 0 0.6rem;
    margin-bottom: 1rem;
    display: flex;

    .item-aba {
      border-radius: 0.5rem;
      padding: 0.3rem 0.8rem 0.3rem 0.5rem;
      background: ${Colors.Color2};
      margin-right: 0.6rem;
      cursor: pointer;
      display: flex;
      flex-direction: row;
      align-items: center;

      span {
        content: "";
        display: block;
        width: 0.8rem;
        height: 0.8rem;
        background: ${Colors.Color4};
        margin-right: 0.5rem;
        margin-left: 0.2rem;
        border-radius: 0.15rem;
      }

      p {
        font-size: 0.8125rem;
        font-weight: 800;
        color: ${Colors.Color7};
      }
    }
    
    .item-aba.ativo {
      background: ${Colors.Color4} !important;

      span {
        background: ${Colors.Color9} !important;
      }

      p {
        color: ${Colors.Color9} !important;
      }
    }

    .h-descricao {
      font-size: 0.7125rem;
      line-height: 0.8rem;
      color: ${Colors.Color7};
    }
  }

  .item-modal {
    display: none;
  }
  
  .item-modal.ativo {
    width: 100%;
    height: 100%;
    display: block;
  }

  .footer {
    position: fixed;
    bottom: 1rem;
    left: 1rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 50%;

    .item-footer {
      margin-right: 1rem !important;
    }

    .btn-imp {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      background: ${Colors.Color4} !important;
      padding: 0.8rem 1rem;
      border-radius: 0.5rem;
      cursor: pointer;
      width: 22rem;

      p {
        font-size: 0.75rem;
        line-height: 0.8rem;
        color: ${Colors.Color1};
        font-weight: 600;
      }
    }
  }

  .lista-calculo {

    .text-h { 
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0.5rem !important;

      input {
        width: 16rem;
      }
    }
  }
`;